import React from "react";

export default function IconPresential2(props) {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_65316_87925)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.99935 1.68424C5.76167 1.68424 4.57469 2.17591 3.69952 3.05108C2.82435 3.92625 2.33268 5.11323 2.33268 6.35091C2.33268 8.15811 3.50853 9.91172 4.79782 11.2726C5.43054 11.9405 6.06524 12.4873 6.54241 12.8672C6.72 13.0086 6.87511 13.1264 6.99935 13.2183C7.12359 13.1264 7.2787 13.0086 7.45629 12.8672C7.93346 12.4873 8.56816 11.9405 9.20088 11.2726C10.4902 9.91172 11.666 8.15811 11.666 6.35091C11.666 5.11323 11.1744 3.92625 10.2992 3.05108C9.42401 2.17591 8.23703 1.68424 6.99935 1.68424ZM6.99935 13.9342C6.67577 14.4196 6.67563 14.4195 6.67546 14.4194L6.67379 14.4183L6.6699 14.4157L6.65654 14.4066C6.64518 14.3989 6.62898 14.3878 6.60826 14.3735C6.56682 14.3448 6.50729 14.303 6.43223 14.2488C6.28217 14.1404 6.06973 13.9822 5.81566 13.7799C5.30846 13.376 4.63066 12.7926 3.95088 12.075C2.61517 10.6651 1.16602 8.62704 1.16602 6.35091C1.16602 4.80381 1.7806 3.32008 2.87456 2.22612C3.96852 1.13216 5.45225 0.517578 6.99935 0.517578C8.54645 0.517578 10.0302 1.13216 11.1241 2.22612C12.2181 3.32008 12.8327 4.80381 12.8327 6.35091C12.8327 8.62704 11.3835 10.6651 10.0478 12.075C9.36804 12.7926 8.69024 13.376 8.18304 13.7799C7.92897 13.9822 7.71653 14.1404 7.56647 14.2488C7.49141 14.303 7.43187 14.3448 7.39044 14.3735C7.36972 14.3878 7.35352 14.3989 7.34216 14.4066L7.32879 14.4157L7.32491 14.4183L7.32368 14.4191C7.32351 14.4192 7.32292 14.4196 6.99935 13.9342ZM6.99935 13.9342L7.32292 14.4196C7.12698 14.5502 6.8714 14.55 6.67546 14.4194L6.99935 13.9342Z"
          fill="#29394D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.99935 5.18424C6.35502 5.18424 5.83268 5.70658 5.83268 6.35091C5.83268 6.99524 6.35502 7.51758 6.99935 7.51758C7.64368 7.51758 8.16602 6.99524 8.16602 6.35091C8.16602 5.70658 7.64368 5.18424 6.99935 5.18424ZM4.66602 6.35091C4.66602 5.06225 5.71068 4.01758 6.99935 4.01758C8.28801 4.01758 9.33268 5.06225 9.33268 6.35091C9.33268 7.63958 8.28801 8.68424 6.99935 8.68424C5.71068 8.68424 4.66602 7.63958 4.66602 6.35091Z"
          fill="#29394D"
        />
      </g>
      <defs>
        <clipPath id="clip0_65316_87925">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.517578)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
